<template>
  <div class="GridConnection">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'
import { gridConnectionValues } from '@/config'

export default {
  name: 'GridConnection',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: 'Aanvraag netaansluiting',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'GridConnection',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: {
        'RequestDate': {
          'type': 'string',
          'title': 'Datum aanvraag netaansluiting',
          'format': 'date',
        },
        'GridOperatorNumber': {
          'type': 'string',
          'title': 'Netbeheerdernummer',
          'format': 'text',
        },
        'ConnectionValue': {
          'type': 'string',
          'title': 'Aansluitwaarde',
          'options': gridConnectionValues,
          'preselected': '3 x 25 A',
          'format': 'select',
        },
      },
      layout: [{
        'columns': '1.2fr 1fr 1fr',
        'fields': ['RequestDate', 'GridOperatorNumber', 'ConnectionValue'],
      }],
      validation: {},
    }
  },
}
</script>
